import { z } from "zod";

export const DTODocumentationPageRoom = z.object({
  id: z.string(),
});

export const DTODocumentationPageRoomResponse = z.object({
  room: DTODocumentationPageRoom,
});

export type DTODocumentationPageRoom = z.infer<typeof DTODocumentationPageRoom>;
export type DTODocumentationPageRoomResponse = z.infer<typeof DTODocumentationPageRoomResponse>;
